import {Button, Card, Collapse, Form, Input, InputNumber, Modal, Tabs, Tooltip, Typography} from "antd";
import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import {useEffect, useRef, useState} from "react";
import DecimalPlacesSettings from "../Components/UserSettings/DecimalPlacesSettings";
import ThresholdSettings from "../Components/UserSettings/ThresholdSettings";
import ApiService from "../Service/ApiService";
import Tolerances from "../Components/UserSettings/DefaultsSettings";
import {useUser} from "../Context/UserContext";
import {ExclamationCircleFilled} from "@ant-design/icons";
import '../input-number.css'
import DefaultsSettings from "../Components/UserSettings/DefaultsSettings";
import {useProject} from "../Context/ProjectContext";

export default function UserSettings() {
    const {user, setSettings} = useUser()
    const {setProjectHistory, clearHistory, setSelectedReportId, setInternalSelectedId, setComparisonBaseId, setComparisonCmpId} = useProject()

    const getValues = () => {
        let form1 = null
        let form2 = null
        let form3 = null

        form1 = fixNullValues(form1, user.defaultSettings.decimalPlaces, user.settings.decimalPlaces || {})
        form2 = fixNullValues(form2, user.defaultSettings.thresholds, user.settings.thresholds || {})
        form3 = fixNullValues(form3, user.defaultSettings.defaults, user.settings.defaults || {})

        return {decimalPlaces: form1, thresholds: form2, defaults: form3}
    }

    const onSave = async ({decimalPlaces, thresholds, defaults}) => {
        const res = await ApiService.User.UpdateUserSettings(JSON.stringify({
            decimalPlaces, thresholds, defaults
        }))

        if(res.success) {
            setSelectedReportId(null)
            setInternalSelectedId(null)
            setComparisonCmpId(null)
            setComparisonBaseId(null)
            clearHistory()

            const res2 = await ApiService.User.UserSettings();
            setSettings({
                settings: JSON.parse(res2.data.settings),
                defaultSettings: res2.data.defaultSettings,
            })
        }
    }

    const onReset = async () => {
        Modal.confirm({
            title: 'Do you want to reset all settings?',
            icon: <ExclamationCircleFilled />,
            content: '',
            onOk() {
                setSelectedReportId(null)
                setInternalSelectedId(null)
                setComparisonCmpId(null)
                setComparisonBaseId(null)
                setSettings({
                    settings: JSON.parse(JSON.stringify(user.defaultSettings)),
                    defaultSettings: JSON.parse(JSON.stringify(user.defaultSettings)),
                })

                onSave({
                    ...user.defaultSettings
                })
            },
            onCancel() {},
        });
    }

    const fixNullValues = (formData, defaultValues, dbValues) => {
        if(!formData) {
            formData = {
                ...defaultValues,
                ...(dbValues ? dbValues : {})
            }
        }

        Object.keys(formData).forEach(x => {
            if(!formData[x])
                formData[x] = dbValues[x] || defaultValues[x]
        })

        return formData
    }

    return (
        <>
            <BaseLayout>
                <Card title={'Settings'}>
                    <Tabs type={'card'} defaultActiveKey={'Thresholds'}>
                        <Tabs.TabPane key={'Thresholds'} tab={'Thresholds'}>
                            <ThresholdSettings
                                values={user?.settings?.thresholds || {}}
                                defValues={user?.defaultSettings?.thresholds || {}}
                                onValuesChange={(key, value) => {
                                    user.settings.thresholds[key] = value
                                    setSettings({
                                        settings: user.settings,
                                        defaultSettings: user.defaultSettings
                                    })
                                }}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane key={'Defaults'} tab={'Defaults'}>
                            <DefaultsSettings
                                values={user?.settings?.defaults || {}}
                                defValues={user?.defaultSettings?.defaults || {}}
                                onValuesChange={(key, value) => {
                                    user.settings.defaults[key] = value
                                    setSettings({
                                        settings: user.settings,
                                        defaultSettings: user.defaultSettings
                                    })
                                }}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane key={'Decimal Places'} tab={'Decimal Places'}>
                            <DecimalPlacesSettings
                                values={user?.settings?.decimalPlaces || {}}
                                defValues={user?.defaultSettings?.decimalPlaces || {}}
                                onValuesChange={(key, value) => {
                                    user.settings.decimalPlaces[key] = value
                                    setSettings({
                                        settings: user.settings,
                                        defaultSettings: user.defaultSettings
                                    })
                                }}
                            />
                        </Tabs.TabPane>
                    </Tabs>
                    <br/>
                    <div style={{display: 'flex', gap: 8}}>
                        <Tooltip title={`Resets the User Preference values to System Default values in Thresholds, Defaults, and Decimal Places settings.`}>
                            <Button
                                danger={true}
                                onClick={onReset}
                            >
                                Reset
                            </Button>
                        </Tooltip>
                        <Tooltip title={`Save the user default values for ${user.data.name} in Thresholds, Defaults and Decimal Places settings`}>
                            <Button
                                type={'primary'}
                                onClick={async () => {await onSave(getValues())}}
                            >
                                Save
                            </Button>
                        </Tooltip>
                    </div>
                </Card>
            </BaseLayout>
        </>
    )
}